import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { makeRequest2 } from '../../../../../../utils/makeRequest';
import { smart_meters_base_url } from "../../../../../../utils/urls";
import { toastify } from '../../../../../../utils/toast';

const SingleDayWaterReadingHistory = ({ meterId }) => {
    const [readings, setReadings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [rows, setRows] = useState(10);
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);

    // Pagination options
    const rowsPerPageOptions = [10, 20, 50, 100];
    const formattedDate = selectedDate
        ? new Date(selectedDate).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        })
        : '';

    useEffect(() => {
        const fetchReadings = async () => {
            if (!meterId) {
                setReadings([]);
                setLoading(false);
                return;
            }
            setLoading(true);
            try {
                const url = `${smart_meters_base_url}/readings/${meterId}?date=${selectedDate}`;
                const response = await makeRequest2(url, 'GET', null);

                if (response.success) {
                    const sortedReadings = (response.data.data.readings || []).sort((a, b) => {
                        return new Date(b.time) - new Date(a.time);
                    });
                    setReadings(sortedReadings);
                } else {
                    toastify('Failed to fetch meter reading history', 'error');
                    setReadings([]);
                }
            } catch (error) {
                toastify('Error fetching meter reading history', 'error');
                setReadings([]);
            } finally {
                setLoading(false);
            }
        };

        fetchReadings();
    }, [meterId, selectedDate]);

    return (
        <div className="row">
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-header">
                        <div className="row mb-2">
                            <div className="col-md-12">
                                <h5>Date: {formattedDate}</h5>
                            </div>
                        </div>
                        <div className="row align-items-end">
                            <div className="col-md-4">
                                <label>Select Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={selectedDate}
                                    onChange={(e) => setSelectedDate(e.target.value)}
                                    max={new Date().toISOString().split('T')[0]}
                                />
                            </div>
                            <div className="col-md-2">
                                <Button
                                    label="Refresh"
                                    onClick={() => setSelectedDate(selectedDate)}
                                    className="btn btn-primary mt-2"
                                    disabled={loading}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <DataTable
                            value={readings}
                            loading={loading}
                            paginator
                            emptyMessage="No readings available for this date"
                            rows={rows}
                            rowsPerPageOptions={rowsPerPageOptions}
                            stripedRows
                            sortOrder={-1}
                            sortField="time"
                        >
                            <Column field="reading" header="Reading (m³)" sortable />
                            <Column field="time" header="Time" sortable />
                            <Column
                                field="status"
                                header="Status"
                                body={(rowData) => (
                                    <span className={`badge bg-${rowData.status === 'opened' ? 'success' : 'warning'}`}>
                                        {rowData.status || 'N/A'}
                                    </span>
                                )}
                                sortable
                            />
                        </DataTable>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SingleDayWaterReadingHistory;
